<section class="publish-success" dir="rtl" aria-labelledby="publish-success-title">
  <div class="publish-success__icon" aria-hidden="true">✓</div>
  <span class="publish-success__eyebrow">המודעה נשלחה</span>
  <!-- SCRUM-177: received, not approved yet - it goes live after admin approval. -->
  <h2 id="publish-success-title">המודעה התקבלה וממתינה לאישור</h2>
  <p>המודעה שלכם התקבלה ותופיע באתר לאחר השלמת הבדיקה.</p>
  <div class="publish-success__note">
    <span aria-hidden="true">i</span>
    ניתן לעקוב אחר סטטוס המודעה באזור האישי
  </div>
  <button type="button" (click)="closeDialog()" routerLink="/">חזרה לעמוד הבית</button>
</section>
